'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yuan2Fen = exports.fen2Yuan = undefined;

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 分转元
 * @param {*} val 
 */
var fen2Yuan = function fen2Yuan(val, needFormat) {
  return needFormat ? (0, _numeral2.default)(val).divide(100).format('0,0.00') : (0, _numeral2.default)(val).divide(100).value().toString();
};

/**
 * 元转分
 * @param {*} val 
 */
var yuan2Fen = function yuan2Fen(val) {
  return (0, _numeral2.default)(val).multiply(100).value().toString();
};

exports.fen2Yuan = fen2Yuan;
exports.yuan2Fen = yuan2Fen;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_alipic-utils@0.0.2@@ali/alipic-utils/lib/number.js
// module id = 266
// module chunks = 6